import React from "react";
import { withStyles, WithStyles } from "@mui/styles";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const styles = {
    rbox: {
        padding: '0.1em',
        paddingLeft: '0.6em',
        paddingRight: '0.6em',
        backgroundColor: '#efeff4',
        borderRadius: '1em',
        alignSelf: 'flex-start',
    },
    gbox: {
        padding: '0.1em',
        paddingLeft: '0.6em',
        paddingRight: '0.6em',
        backgroundColor: '#D2F7ED',
        borderRadius: '1em',
        alignSelf: 'flex-start',
    },
    rtext: {
        color: '#8181A5',
        fontSize: '0.9em',
        fontWeight: 'bold',
        opacity: 1
    },
    gtext: {
        color: '#21D8A5',
        fontSize: '0.9em',
        fontWeight: 'bold'
    }
}

interface ActiveBoxProps extends WithStyles<typeof styles> {
    value: any; // Assuming 'value' is a boolean indicating if active or inactive
}

const ActiveBox: React.FC<ActiveBoxProps> = ({ classes, value }) => {
    const { t } = useTranslation();
    return (
        <Box className={!value ? classes.rbox : classes.gbox}>
            <Typography className={!value ? classes.rtext : classes.gtext}>
                {!value ? t('Inactive') : t('Active')}
            </Typography>
        </Box>
    )
}

export default withStyles(styles)(ActiveBox);
